import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/useBoundStore';
import type { SocureData } from '@Hooks/socure/useSocureBaseLogic';

export const sendValidationMessage = async (customerId: string) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/uploadRequest`
    : `v2/secureonboarding/user/${customerId}/uploadRequest`;

  const { data } = await HttpService.get<SocureData>(url);
  return data;
};
